// import path from 'path'
// import HtmlWebpackPlugin from 'html-webpack-plugin'
// import CopyWebpackPlugin from 'copy-webpack-plugin'
import CleanWebpackPlugin from 'clean-webpack-plugin'
// import ExtractTextPlugin from "extract-text-webpack-plugin"
// import postCSSNext from 'postcss-cssnext'
// import glob from 'glob'
// import opn from 'opn'
// import os from 'os'
import configureClient from './configure-client.js'
import configureServer from './configure-server.js'
import fs from 'fs-extra'
import inspectorServer from './node-inspector-server'
import { clearTerminal } from './terminal-utils'
import { setupFurtherDir, ensureEditorConfig } from './meta-manager'

export default function getWebpackConfig (opts = {}, PATHS, appRef) {
  // setting some evironment constants based on the settings
  const IS_DEV = opts.mode === 'dev'
  const PROJECT_PATH = PATHS.project // path.resolve(path.dirname(process.argv[1]))
  const OUTPUT_PATH = PATHS.dist // path.resolve(PROJECT_PATH, opts.outputPath)
  const SRC_PATH = PATHS.src // path.resolve(PROJECT_PATH, opts.src)
  const FURTHER_PATH = PATHS.further // process.cwd()
  const USED_EXTENSIONS = PATHS.usedExtensions
  const FURTHER_REF = PATHS.furtherRef
  // const AVAILABLE_ALIASES = [
  //   'react',
  //   'Components',
  //   'Comps',
  //   'Main',
  //   'Utils',
  //   'Templates'
  // ]

  return new Promise(async resolve => {
    opts.outputPath = opts.outputPath || 'dist'
    opts.src = opts.src || 'src'
    opts.development = opts.development || {}
    opts.production = opts.production || {}

    // function SilentHardSource() {}
    // SilentHardSource.prototype.apply = function(compiler) {
    //   compiler.plugin('hard-source-log', function(message) {
    //     if (message.level === 'error' /* || message.level === 'warning' */) {
    //       console[message.level].call(
    //         console,
    //         'hard-source:' + message.from, message.message
    //       );
    //     }
    //   });
    // }

    const COMMON_CONFIG = {
      context: PROJECT_PATH,
      plugins: [
        new CleanWebpackPlugin([opts.outputPath], {
          root: PROJECT_PATH,
          verbose: false,
          silent: true
        }),
        // new SilentHardSource()
      ],
      resolve: {
        extensions: [ ".webpack.js", ".web.js", ".ts", ".js", ".tsx", ".mjs", ".jsx", ".coffee", ".vue", ".less", ".styl", ".sass" ],
        alias: {}
      }
    }
    
    const CLI_CONFIG = {}

    function configureCli () {
      CLI_CONFIG.target = 'async-node'
      return Object.assign({}, COMMON_CONFIG, CLI_CONFIG)
    }
    
    clearTerminal()

    // if it is in devMode and debug is true
    if (IS_DEV && opts.debug) {
      await inspectorServer().then()
    }
    await configure()

    async function configure () {
      const state = {
        COMMON_CONFIG,
        SRC_PATH,
        OUTPUT_PATH,
        IS_DEV,
        PROJECT_PATH,
        FURTHER_PATH,
        // FURTHER_REF: PATHS.furtherRef,
        appRef: appRef,
        USED_EXTENSIONS,
        FURTHER_REF,
      }
      
      await setupFurtherDir(PATHS)
      await fs.ensureDir(PATHS.src)
      await ensureEditorConfig(PATHS)

      let pList = []
      if (opts.server) {
        pList.push(configureServer(opts, state, appRef))
      }
      if (opts.client) {
        pList.push(configureClient(opts, state, appRef))
      }
      if (opts.cli) {
        pList.push(configureCli(opts, state, appRef))
      }

      Promise.all(pList).then(result => {
        resolve(result)
      }).catch(err => {
        console.error(err)
      })
    }
  })
}


// WEBPACK FOOTER //
// ./src/app.wp-config.js